import { useState } from "react";
import { supabase } from "../../../supabase";
import CropModal from "./CropModal";
import Header from "../Header";

function AddGallery() {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [preview, setPreview] = useState(null);
  const [croppedFile, setCroppedFile] = useState(null);
  const [rawImage, setRawImage] = useState(null);
  const [openCrop, setOpenCrop] = useState(false);
  const [loading, setLoading] = useState(false);

  const onSelectFile = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      setRawImage(reader.result);
      setOpenCrop(true);
    };
  };

  const handleCropDone = (file) => {
    setCroppedFile(file);
    setPreview(URL.createObjectURL(file));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!title || !croppedFile) {
      alert("Title & image required");
      return;
    }

    setLoading(true);

    let insertedId = null;

    try {
      /* 1️⃣ Insert into DB FIRST (no image yet) */
      const { data: insertedData, error: insertError } = await supabase
        .from("gallery")
        .insert([
          {
            title,
            description,
            url: null, // temp
          },
        ])
        .select()
        .single();

      if (insertError) throw insertError;

      insertedId = insertedData.id;

      /* 2️⃣ Upload image using ID */
      const fileName = `${insertedId}.webp`;

      const { error: uploadError } = await supabase.storage
        .from("gallery")
        .upload(fileName, croppedFile);

      if (uploadError) throw uploadError;

      /* 3️⃣ Get public URL */
      const { data: publicUrlData } = supabase.storage
        .from("gallery")
        .getPublicUrl(fileName);

      /* 4️⃣ Update table with image URL */
      const { error: updateError } = await supabase
        .from("gallery")
        .update({
          url: publicUrlData.publicUrl,
        })
        .eq("id", insertedId);

      if (updateError) throw updateError;

      alert("Gallery item saved successfully!");

      // Reset form
      setTitle("");
      setDescription("");
      setPreview(null);
      setCroppedFile(null);
    } catch (error) {
      console.error("Error:", error);

      /* 5️⃣ ROLLBACK: delete DB row if image failed */
      if (insertedId) {
        await supabase.from("gallery").delete().eq("id", insertedId);
      }

      alert("Operation failed. No partial data saved.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <main className="main-content" id="mainContent">
        <Header heading="Gallery" />
        <form onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-lg-8">
              {" "}
              <input
                placeholder="Title"
                className="form-control mb-2"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
              <textarea
                className="form-control mb-2"
                placeholder="Description"
                rows={8}
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </div>
            <div className="col-lg-4">
              {preview && (
                <img
                  src={preview}
                  alt="Preview"
                  style={{ width: "100%", marginTop: 10 }}
                />
              )}
              <input
                type="file"
                className="form-control mt-1"
                accept="image/*"
                onChange={onSelectFile}
              />

              <button className="btn btn-primary mt-3 w-100" disabled={loading}>
                {loading ? "Saving..." : "Upload Image"}
              </button>
            </div>
          </div>
        </form>

        {openCrop && (
          <CropModal
            imageSrc={rawImage}
            onClose={() => setOpenCrop(false)}
            onCropDone={handleCropDone}
          />
        )}
      </main>
    </>
  );
}

export default AddGallery;
